import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnassignedConversations = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 30,
	viewBox: "0 0 33 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7129 27.5C11.1948 27.5 11.5322 27.259 12.0984 26.7289L16.4599 22.753L24.5924 22.7651C28.1828 22.7771 30.1104 20.7771 30.1104 17.247V8.01809C30.1104 4.48796 28.1828 2.5 24.5924 2.5H9.07436C5.49601 2.5 3.55627 4.47588 3.55627 8.01809V17.247C3.55627 20.7892 5.49601 22.7651 9.07436 22.753H9.64059V26.2591C9.64059 27.006 10.0382 27.5 10.7129 27.5Z",
			fill: "#E4EAEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9514 17.9935C15.9514 18.2206 16.1349 18.4049 16.361 18.4049H17.1801C17.4062 18.4049 17.5897 18.2206 17.5897 17.9935V17.1707C17.5897 16.9436 17.4062 16.7593 17.1801 16.7593H16.361C16.1349 16.7593 15.9514 16.9436 15.9514 17.1707V17.9935Z",
			fill: "#416774"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5481 12.7851L19.2854 12.0282C20.1201 11.1897 20.4052 9.74732 19.4386 8.40449C18.698 7.37598 17.5143 6.73089 16.2659 6.92425C15.0011 7.12008 13.9755 8.04245 13.6241 9.25363C13.4914 9.71276 13.824 10.1768 14.2999 10.1768H14.5383C14.8602 10.1768 15.1158 9.94973 15.2207 9.64447C15.4902 8.86033 16.3347 8.33949 17.2407 8.59785C17.815 8.76159 18.268 9.26351 18.3786 9.85346C18.4867 10.4303 18.2999 10.9717 17.9256 11.337L16.9098 12.3737C16.32 12.9744 15.9514 13.7972 15.9514 14.7023V15.1137H17.5897C17.5897 13.8795 17.9583 13.3858 18.5481 12.7851Z",
			fill: "#416774"
		})
	]
});
const ForwardRef = forwardRef(SvgUnassignedConversations);
export { ForwardRef as ReactComponent };
